<template>
  <v-app id="inspire">
    <LogOutWarning
      :jwtToken="$store.state.token"
      v-if="
        $store.state.token && $store.state.usuario.rol == 'Coordinador Cabina'
      "
    />

    <template v-if="$store.state.token">
      <MiniNotificacionSocial
        v-if="
          $store.state.usuario.rol == 'Coordinador Cabina' ||
          $store.state.usuario.rol == 'Team Leader Cabina'
        "
      />
    </template>

    <v-navigation-drawer
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      :clipped="$vuetify.breakpoint.mdAndUp"
      app
      v-model="drawer"
      v-if="logueado && !isOperadorGrua && !isCorredor"
      floating
    >
      <v-list dense nav rounded>
        <v-list-item>
          <v-list-item-avatar horizontal height="auto" class="mx-auto">
            <v-img :src="require('@/assets/iconLogoName.png')"></v-img>
          </v-list-item-avatar>
          <v-list-item-title class="body-2 ml-4"
            >Asistencia Regional</v-list-item-title
          >
        </v-list-item>
        <v-divider dark light class="mb-1"></v-divider>

        <!--Novedades -->
        <v-list-item
          :to="{ name: 'novedades' }"
          color="#00ff001C"
          v-if="permisoModulo('Novedades')"
        >
          <v-list-item-action>
            <span style="color: black">
              <i class="far fa-newspaper"></i>
            </span>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color: black">
              Novedades
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!--Grafico -->
        <v-list-item :to="{ name: 'graficos' }" v-if="permisoModulo('Gráfico')">
          <v-list-item-action>
            <i class="fas fa-chart-bar"></i>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Gráfico </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- AdminArchivos -->
        <v-list-item
          :to="{ name: 'adminArchivos' }"
          v-if="permisoModulo('AdminArchivos') && false"
        >
          <v-list-item-action>
            <i class="fas fa-cloud"></i>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> One Drive (Beta) </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!--Bases -->
        <template
          v-if="
            permisoModulo('Base de datos Futuro') ||
            permisoModulo('Base de datos Assa')
          "
        >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Bases </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'baseFuturo' }"
              v-if="permisoModulo('Base de datos Futuro')"
            >
              <v-list-item-action>
                <i class="fas fa-database"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Base de datos Futuro </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'baseAssa' }"
              v-if="permisoModulo('Base de datos Assa')"
            >
              <v-list-item-action>
                <i class="fas fa-database"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Base de datos Assa </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'baseSisa' }"
              v-if="permisoModulo('Base de datos SISA')"
            >
              <v-list-item-action>
                <i class="fas fa-database"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Base de datos SISA </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Informes -->
        <template v-if="permisoModulo('Informe') || permisoModulo('Costos')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Informes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'informe' }"
              v-if="permisoModulo('Informe')"
            >
              <v-list-item-action>
                <i class="fas fa-file-download"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Informe </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'sumaCostos' }"
              v-if="permisoModulo('Costos')"
            >
              <v-list-item-action>
                <i class="fas fa-funnel-dollar"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Costos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!-- SLAs -->
        <template v-if="permisoModulo('SLA Sisa')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> SLAs </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'SLASisa' }"
              v-if="permisoModulo('SLA Sisa')"
            >
              <v-list-item-action>
                <i class="fas fa-file-alt"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Base SISA </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!-- Whatsapp -->
        <template v-if="permisoModulo('WhatsApp')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> WhatsApp </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'contactoWA' }"
              v-if="permisoModulo('WhatsApp')"
            >
              <v-list-item-action>
                <i class="fab fa-whatsapp"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> WhatsApp </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item
              :to="{ name: 'plantillasWaApi' }"
              v-if="permisoModulo('PlantillaWaApi')"
            >
              <v-list-item-action>
                <i class="fab fa-whatsapp"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Plantillas </v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          </v-list-group>
        </template>

        <!-- GestionOperativa -->
        <template v-if="permisoModulo('GestionOperativa')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Gestión Operativa </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'ModeloSLA' }">
              <v-list-item-action>
                <i class="fas fa-tasks"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Modelo SLA </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Registro -->
        <template
          v-if="
            permisoModulo('Plantilla') ||
            permisoModulo('Cabina') ||
            permisoModulo('Historico') ||
            permisoModulo('Bitacora') ||
            permisoModulo('Coordenadas') ||
            permisoModulo('Reincidencia') ||
            permisoModulo('Guardia') ||
            permisoModulo('Guardia V2') ||
            permisoModulo('Parte Policial')
          "
        >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Registro </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'AuditLogs' }"
              v-if="permisoModulo('AuditLogs')"
            >
              <v-list-item-action>
                <i class="fas fa-history"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Logs </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              :to="{ name: 'plantilla' }"
              v-if="permisoModulo('Plantilla')"
            >
              <v-list-item-action>
                <i class="fas fa-search"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Plantilla </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'cabina' }"
              v-if="permisoModulo('Cabina')"
            >
              <v-list-item-action>
                <i class="fas fa-table"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Cabina </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'historico' }"
              v-if="permisoModulo('Historico')"
            >
              <v-list-item-action>
                <i class="fas fa-book-open"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Historico </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'bitacora' }"
              v-if="permisoModulo('Bitacora')"
            >
              <v-list-item-action>
                <i class="fas fa-marker"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Bitacora </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'proveedoresAsignados' }"
              v-if="permisoModulo('Proveedores Asignados')"
            >
              <v-list-item-action>
                <i class="fas fa-clipboard-list"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Proveedores Asignados</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'partePolicial' }"
              v-if="permisoModulo('Parte Policial')"
            >
              <v-list-item-action>
                <i class="fas fa-marker"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Parte Policial </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'coordenadas' }"
              v-if="permisoModulo('Coordenadas')"
            >
              <v-list-item-action>
                <i class="fas fa-search-location"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Coordenadas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'verificarFuturo' }" v-if="false">
              <v-list-item-action>
                <i class="fas fa-eye"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Verificación Futuro </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'reincidencia' }"
              v-if="permisoModulo('Reincidencia')"
            >
              <v-list-item-action>
                <i class="fas fa-table"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Reincidencia </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'guardiav1' }"
              v-if="permisoModulo('Guardia')"
            >
              <v-list-item-action>
                <i class="fab fa-wpforms"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Guardia </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'guardia' }"
              v-if="permisoModulo('Guardia V2')"
            >
              <v-list-item-action>
                <i class="fas fa-exclamation" :style="{ color: 'red' }"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Guardia V2</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'HistorialServiciosConexion' }">
              <v-list-item-action>
                <i class="fas fa-link"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Servicios Conexión </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'usuariosCartera' }"
              v-if="permisoModulo('UsuarioCartera')"
            >
              <v-list-item-action>
                <i class="fas fa-user-edit"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Carteras Por Usuarios </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <template v-if="permisoModulo('Horarios Empleado')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Horarios </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'Horario' }">
              <v-list-item-action>
                <i class="far fa-clock"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Horarios </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'HorariosEmpleados' }">
              <v-list-item-action>
                <i class="fas fa-user-clock"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Horarios Empleados </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!-- Evaluacion de Calidad -->
        <template v-if="permisoModulo('Evaluacion de Calidad')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Evaluación de Calidad </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'HistorialEncuestas' }">
              <v-list-item-action>
                <i class="fas fa-poll"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Encuestas (SISA) </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'HistorialEncuestasGeneral' }">
              <v-list-item-action>
                <i class="fas fa-poll"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Estadísticas Operador </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'HistorialReenvioEncuestas' }">
              <v-list-item-action>
                <i class="fas fa-history"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Historial Reenvios </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'Preguntas' }">
              <v-list-item-action>
                <i class="fas fa-question"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Preguntas (SISA) </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!-- Marcaciones -->
        <template v-if="permisoModulo('Marcaciones')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Marcaciones </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'HistorialMarcaciones' }">
              <v-list-item-action>
                <i class="fas fa-fingerprint"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Historial </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'EmpleadosMarcaciones' }">
              <v-list-item-action>
                <i class="fas fa-users"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Empleados </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'DepartamentosMarcaciones' }">
              <v-list-item-action>
                <i class="fas fa-sitemap"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Departamentos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'PosicionesMarcaciones' }">
              <v-list-item-action>
                <i class="fas fa-user-tag"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Posiciones </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'Horario' }">
              <v-list-item-action>
                <i class="far fa-clock"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Horarios </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'HorariosEmpleados' }">
              <v-list-item-action>
                <i class="fas fa-user-clock"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Horarios Empleados </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!-- Intranet -->
        <template
          v-if="permisoModulo('Noticias') || permisoModulo('Compartido')"
        >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Intranet </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'noticias' }"
              v-if="permisoModulo('Noticias')"
            >
              <v-list-item-action>
                <i class="far fa-newspaper"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Noticias </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'compartido' }"
              v-if="permisoModulo('Compartido')"
            >
              <v-list-item-action>
                <i class="fas fa-share-alt"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Compartido </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Solicitudes -->
        <template
          v-if="
            permisoModulo('Solicitud grabación') ||
            permisoModulo('Solicitud información') ||
            permisoModulo('Solicitud AR')
          "
        >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Solicitudes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              :to="{ name: 'solicitudGrabacion' }"
              v-if="permisoModulo('Solicitud grabación')"
            >
              <v-list-item-action>
                <i class="far fa-file-audio"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Solicitud grabación </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'solicitudInformacion' }"
              v-if="permisoModulo('Solicitud información')"
            >
              <v-list-item-action>
                <i class="far fa-file-alt"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Solicitud información </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'solicitudesAR' }"
              v-if="permisoModulo('Solicitud AR')"
            >
              <v-list-item-action>
                <i class="fas fa-inbox"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Solicitud AR </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--App movil -->
        <template
          v-if="
            permisoModulo('Asistencias App Movil') ||
            permisoModulo('Reembolso App Movil') ||
            permisoModulo('App Movil Historial') ||
            permisoModulo('App Movil Proveedores')
          "
        >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> App Movil </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'asistenciasApp' }"
              v-if="permisoModulo('Asistencias App Movil')"
            >
              <v-list-item-action>
                <i class="fas fa-mobile-alt" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Asistencias App Movil </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'reembolsoApp' }"
              v-if="permisoModulo('Reembolso App Movil')"
            >
              <v-list-item-action>
                <i class="fas fa-hand-holding-usd"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Reembolso App Movil </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'historialApp' }"
              v-if="permisoModulo('App Movil Historial')"
            >
              <v-list-item-action>
                <i class="fas fa-list-ul"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> App Movil Historial </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'proveedoresApp' }"
              v-if="permisoModulo('App Movil Proveedores')"
            >
              <v-list-item-action>
                <i class="fas fa-user-check"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> App Movil Proveedores </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <v-list-item
          :to="{ name: 'mapaProveedores' }"
          v-if="permisoModulo('Mapa Proveedores')"
        >
          <v-list-item-action>
            <i class="fas fa-map-marked-alt"></i>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Mapa Proveedores </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'asistenciaProveedor' }" v-if="false">
          <v-list-item-action>
            <i class="fas fa-users-cog"></i>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Asistencia proveedor </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'diseñoProveedores' }"
          v-if="permisoModulo('Proveedores')"
        >
          <v-list-item-action>
            <i class="far fa-handshake"></i>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Proveedores </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'operadoresGrua' }"
          v-if="permisoModulo('Operadores Grua')"
        >
          <v-list-item-action>
            <i class="far fa-handshake"></i>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Proveedores Grua </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'imagenesProvider' }" v-if="false">
          <v-list-item-action>
            <i class="far fa-images"></i>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Imagenes </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'bitacoraProvider' }" v-if="false">
          <v-list-item-action>
            <i class="fas fa-marker"></i>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Bitacora Provider </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Historial -->
        <template v-if="permisoModulo('Historial')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Historial de Turnos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'HistorialOperadoresGrua' }"
              v-if="permisoModulo('Historial')"
            >
              <v-list-item-action>
                <i class="fas fa-history"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Operadores Grúas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'HistorialOperadoresCabina' }"
              v-if="permisoModulo('Historial')"
            >
              <v-list-item-action>
                <i class="fas fa-headset"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Operadores Cabina </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'HistorialInspectores' }"
              v-if="permisoModulo('Historial')"
            >
              <v-list-item-action>
                <i class="fas fa-search-location"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Inspectores </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'HistorialGuardia' }"
              v-if="
                $store.state.usuario.rol == 'Administrador' ||
                $store.state.usuario.rol == 'Personal Administrativo' ||
                $store.state.usuario.rol == 'Team Leader Cabina'
              "
            >
              <v-list-item-action>
                <i class="fas fa-clipboard-list"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Historial Guardia</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Legales -->
        <template v-if="permisoModulo('Asistencias legales')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Legales </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'legales' }"
              v-if="permisoModulo('Asistencias legales')"
            >
              <v-list-item-action>
                <i class="fas fa-balance-scale"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Asistencias legales </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Internacionales -->
        <template v-if="permisoModulo('Servicios Internacionales')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Internacionales </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'internacionales' }"
              v-if="permisoModulo('Servicios Internacionales')"
            >
              <v-list-item-action>
                <i class="fas fa-globe-americas"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Servicios Internacionales
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <template v-if="false">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Evaluaciones </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'evaluacion' }">
              <v-list-item-action>
                <i class="fab fa-wpforms"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Evaluaciones </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Formalrios -->
        <template
          v-if="
            permisoModulo('Base proveedores') ||
            permisoModulo('Base clientes') ||
            permisoModulo('Bauchers') ||
            permisoModulo('CCF') ||
            permisoModulo('Recibos Renta') ||
            permisoModulo('Consumidor Final') ||
            permisoModulo('Sujeto Excluido')
          "
        >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Formularios </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'baseProveedoresbaucher' }"
              v-if="permisoModulo('Base proveedores')"
            >
              <v-list-item-action>
                <i class="fa fa-database"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Base proveedores </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'baseClientesFactura' }"
              v-if="permisoModulo('Base clientes')"
            >
              <v-list-item-action>
                <i class="fa fa-database"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Base clientes </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'bauchers' }"
              v-if="permisoModulo('Bauchers')"
            >
              <v-list-item-action>
                <i class="fab fa-wpforms"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Bauchers </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'facturas' }" v-if="permisoModulo('CCF')">
              <v-list-item-action>
                <i class="fab fa-wpforms"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> CCF </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'reciboRenta' }"
              v-if="permisoModulo('Recibos Renta')"
            >
              <v-list-item-action>
                <i class="fab fa-wpforms"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Recibos Renta </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'consumidorFinal' }"
              v-if="permisoModulo('Consumidor Final')"
            >
              <v-list-item-action>
                <i class="fab fa-wpforms"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Consumidor Final </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'sujetoExcluido' }"
              v-if="permisoModulo('Sujeto Excluido')"
            >
              <v-list-item-action>
                <i class="fab fa-wpforms"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Sujeto Excluido </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Pagos -->
        <template v-if="permisoModulo('Pagos Proveedores')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Pagos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'pagosProveedor' }"
              v-if="permisoModulo('Pagos Proveedores')"
            >
              <v-list-item-action>
                <i class="fas fa-file-invoice"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Pagos Proveedores </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Quedan -->
        <template v-if="permisoModulo('Quedan')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Quedan </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'quedan' }"
              v-if="permisoModulo('Quedan')"
            >
              <v-list-item-action>
                <i class="fas fa-file-invoice"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Quedan </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!--Accesos -->
        <template
          v-if="
            permisoModulo('Roles') ||
            permisoModulo('Usuarios') ||
            permisoModulo('Usuarios Web') ||
            permisoModulo('Modulos')
          "
        >
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Accesos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'roles' }" v-if="permisoModulo('Roles')">
              <v-list-item-action>
                <i class="fas fa-fingerprint"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Roles </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'AuditLogs' }"
              v-if="permisoModulo('Usuarios')"
            >
              <v-list-item-action>
                <i class="fas fa-history"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Logs </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'usuarios' }"
              v-if="permisoModulo('Usuarios')"
            >
              <v-list-item-action>
                <i class="fas fa-users"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Usuarios </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'usuariosWeb' }"
              v-if="permisoModulo('Usuarios Web')"
            >
              <v-list-item-action>
                <i class="fas fa-users"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Usuarios Web </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'modulos' }"
              v-if="permisoModulo('Modulos')"
            >
              <v-list-item-action>
                <i class="fas fa-users"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Modulos </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              :to="{ name: 'carteras' }"
              v-if="permisoModulo('Carteras')"
            >
              <v-list-item-action>
                <i class="fas fa-wallet"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Carteras </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>

        <!-- CONFIGURACIONES -->
        <template v-if="permisoModulo('Configuraciones')">
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title> Configuraciones </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'Extensiones' }">
              <v-list-item-action>
                <i class="fas fa-phone-alt"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Extensiones </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'Equipos' }">
              <v-list-item-action>
                <i class="fas fa-toolbox"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Equipos Inspectores </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'TipoAsistencias' }">
              <v-list-item-action>
                <i class="fas fa-people-carry"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Tipo Asistencias </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{ name: 'Preguntas' }">
              <v-list-item-action>
                <i class="fas fa-question"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Preguntas SISA </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link @click="openWaKey">
              <v-list-item-action>
                <i class="fas fa-key"></i>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>WA WebHook Key</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <WaWebhookDialog ref="waDialog" />
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      :src="
        currentRoute == 'EncuestaSisa' && !logueado
          ? ''
          : 'https://picsum.photos/id/387/3072/2048'
      "
      dark
      app
      dense
      :color="currentRoute == 'EncuestaSisa' && !logueado ? 'white' : ''"
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon
          v-if="logueado && !isOperadorGrua && !isCorredor"
          @click.stop="drawer = !drawer"
        />

        <v-row v-if="currentRoute == 'EncuestaSisa' && !logueado">
          <v-img :src="require('@/assets/SISA.png')" height="45" contain>
          </v-img>
        </v-row>
        <span>{{
          currentRoute == "EncuestaSisa" && !logueado
            ? ""
            : "Asistencia Regional"
        }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <cronometro
        v-if="verCronometro"
        @cronometro="activarNotificacionCronometro"
      ></cronometro>
      <v-spacer></v-spacer>
      <span
        class="title text"
        style="color: white"
        v-if="logueado"
        ref="notificationApp"
        >{{ this.$store.state.usuario.nombre }}</span
      >
      <v-btn @click="salir" icon v-if="logueado || isOperadorGrua">
        <i class="fas fa-sign-out-alt fa-2x"></i>
      </v-btn>
    </v-app-bar>

    <v-content
      :style="noPadding ? 'padding: 0px' : ''"
      style="background-color: white"
    >
      <v-slide-y-transition mode="out-in">
        <router-view />
      </v-slide-y-transition>
    </v-content>

    <div id="mySidenav" class="sidenav" v-if="logueado && false">
      <a @click="openMap()" id="dialogMap">Zonas Rojas</a>
    </div>

    <Map
      :estado="componentMap"
      @estadoMapa="componentMap = $event"
      v-if="componentMap"
    />

    <v-footer
      height="auto"
      padless
      v-if="
        currentRoute != 'EncuestaSisa' &&
        currentRoute != 'contactoWA' &&
        logueado
      "
    >
      <v-layout justify-center>
        <v-flex text-right>
          <v-card flat tile dark class="color">
            <v-card-text class="black--text">
              {{ versionPlataforma }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import Cronometro from "./components/Cronometro";
import LogOutWarning from "./components/LogOutWarning.vue";
import Map from "./components/Mapa";
import MiniNotificacionSocial from "./components/Minis/MiniNotificacionSocial.vue";
import WaWebhookDialog from "./components/WaWebhookDialog.vue";
const signalR = require("@microsoft/signalr");
import { dbRefAsistencias, dbRefProveedor, dbVersionSistema } from "./main";
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      versionWeb: process.env.VUE_APP_PLATAFORMA_VERSION,
      version: 1.0,
      drawer: false,
      fab: false,
      componentMap: false,
      banderaNotificacionApp: false,
      audio: new Audio(require("./assets/tono_notification.mp3")),
      flag: false,
      permisos: [],
      connection: "",
    };
  },
  props: {
    estadoMap: null,
  },
  components: {
    Map,
    Cronometro,
    LogOutWarning,
    MiniNotificacionSocial,
    WaWebhookDialog,
  },
  computed: {
    // Verificar si la ruta actual tiene la propiedad meta.noPadding
    noPadding() {
      return this.$route.meta.noPadding || false;
    },
    currentRoute() {
      return this.$route.name;
    },
    versionPlataforma() {
      return `Sistema v${this.versionWeb} © ${new Date().getFullYear()}`;
    },
    isAdmin() {
      if (this.$store.state.usuario) {
        return this.$store.state.usuario.rol == "Administrador" ? true : false;
      }
      return false;
    },
    isOperadorGrua() {
      if (this.$store.state.usuario) {
        if (this.$store.state.usuario.rol == "Operador Grua") {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    isCorredor() {
      if (this.$store.state.usuario) {
        if (this.$store.state.usuario.rol == "Corredores") {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    logueado() {
      if (this.$store.state.usuario) {
        this.listarPermisos(this.$store.state.usuario.idRol);
        this.listarAcciones();
        this.notificationApp();
      }
      return this.$store.state.usuario;
    },
    verCronometro() {
      if (
        this.$store.state.usuario &&
        (this.$store.state.usuario.rol == "Usuario" ||
          this.$store.state.usuario.rol == "Coordinador Cabina")
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeMount() {
    this.$store.dispatch("autoLogin");
    this.checkVersionSistema();
  },
  mounted() {
    // this.connection.on("Receive", (model) => {
    //   axios
    //     .get(
    //       "api/WhatsAppApi/ListarPorIdWa/" +
    //         model.entry[0].changes[0].value.messages[0].id
    //     )
    //     .then((response) => {
    //       this.alertaMensaje(
    //         "Nuevo mensaje de WhatsApp, Tel: " +
    //           response.data.numero_contacto +
    //           " de la asistencia: " +
    //           response.data.numero_asistencia
    //       );
    //     });
    // });
  },
  created() {
    //console.log(this.$store.state.usuario);
    this.drawer = this.$vuetify.breakpoint.mdAndUp;

    // this.esuchadorApi();
  },
  methods: {
    openWaKey() {
      this.$refs.waDialog.open();
    },
    alertaMensaje(mensaje) {
      this.$toast.info(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 0,
      });
    },
    rolUsuario() {
      if (this.$store.state.usuario.rol == "Usuario") {
        return true;
      }
    },
    esuchadorApi() {
      // this.connection = new signalR.HubConnectionBuilder()
      //   .withAutomaticReconnect()
      //   .withUrl(process.env.VUE_APP_AXIOS + "/callWhatsAppApi", {
      //     skipNegotiation: true,
      //     transport: signalR.HttpTransportType.WebSockets,
      //   })
      //   .build();
      // this.connection
      //   .start()
      //   .then(() => {
      //     console.log("Conexión establecida");
      //   })
      //   .catch(() => {
      //     console.log("No se pudo conectar");
      //   });
    },
    listarPermisos(id) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Permisos/Listar/" + id, configuracion)
        .then((response) => {
          this.permisos = response.data;
          this.$store.dispatch("guardarPermisos", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    listarAcciones() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/accionesXroles/Listar/" + this.$store.state.usuario.idRol,
          configuracion
        )
        .then((response) => {
          this.$store.dispatch("guardarAcciones", response.data);
        });
    },
    permisoModulo(item) {
      var index = this.permisos.findIndex((object) => {
        return object.nombre_modulo == item;
      });
      if (index != -1) {
        return true;
      }
    },
    salir() {
      this.$store.dispatch("salir");
    },
    openMap() {
      this.componentMap = true;
    },
    checkVersionSistema() {
      let me = this;
      dbVersionSistema.on("value", function (childSnapshot, prevChildKey) {
        if (me.version == childSnapshot.val()) {
          console.log(childSnapshot.val());
          me.nuevaVersionSistema();
        }
      });
    },
    notificationApp() {
      let me = this;

      dbRefAsistencias.off("child_added");
      dbRefAsistencias.on("child_added", function () {
        me.activarNotificacionAdded();
      });

      dbRefAsistencias.off("child_changed");
      dbRefProveedor.on("child_changed", function () {
        me.notificacionproveedor();
      });

      dbRefAsistencias.on("child_changed", function (childSnapshot) {
        if (childSnapshot.val().title == "NOTIFICACION CABINA") {
          if (childSnapshot.val().timeContact && childSnapshot.val().timeEnd) {
            me.actualizarFechaContactoTermino(
              childSnapshot.val().idCabina,
              childSnapshot.val().timeContact,
              childSnapshot.val().timeEnd
            );
          } else {
            me.actualizarFechaContacto(
              childSnapshot.val().idCabina,
              childSnapshot.val().timeContact
            );
          }
          me.activarNotificacionChanged(childSnapshot.val().placa);
        } else {
          me.activarNotificacionChanged(childSnapshot.val().plateVehicle);
        }
      });
    },
    actualizarFechaContactoTermino(idCabina, timeContact, timeEnd) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .put(
          "api/Cabinas/AsistenciaProveedor",
          {
            idCabina: idCabina,
            //idBase: me.idBase,
            //idUsuario: me.idUsuario,
            //idProveedor: me.idProveedor,
            fechaHoraContacto: timeContact,
            termino: timeEnd,
          },
          configuracion
        )
        .then(function (response) {
          if (response.status == 200) {
            //me.overlayDate = false;
            //me.dialogConfirmarFecha = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          //me.overlayDate = false;
          //me.snackError = true;
        });
    },
    actualizarFechaContacto(idCabina, timeContact) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .put(
          "api/Cabinas/AsistenciaProveedor",
          {
            idCabina: idCabina,
            //idBase: me.idBase,
            //idUsuario: me.idUsuario,
            //idProveedor: me.idProveedor,
            fechaHoraContacto: timeContact,
            termino: "",
          },
          configuracion
        )
        .then(function (response) {
          if (response.status == 200) {
            //me.overlayDate = false;
            //me.dialogConfirmarFecha = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          //me.overlayDate = false;
          //me.snackError = true;
        });
    },
    activarNotificacionAdded() {
      this.playAudio(true);
      this.$swal
        .fire({
          title: "Nueva asistencias de la aplicación movil.",
          width: 600,
          padding: "3em",
          background: "#fff",
          backdrop: `
          rgba(0,0,123,0.4)
          left top
          no-repeat
        `,
        })
        .finally(() => {
          this.playAudio(false);
        });
    },
    activarNotificacionChanged(placa) {
      this.playAudio(true);
      this.$swal
        .fire({
          title:
            "Hubo cambios en la asistencia de la aplicación movil con la placa " +
            placa,
          width: 600,
          padding: "3em",
          background: "#fff",
          backdrop: `
          rgba(0,0,123,0.4)
          left top
          no-repeat
        `,
        })
        .finally(() => {
          this.playAudio(false);
        });
    },
    nuevaVersionSistema() {
      this.$swal
        .fire({
          title: "Hay cambios en el sistema, favor de recargar el navegador.",
          width: 600,
          padding: "3em",
          background: "#fff url(/images/trees.png)",
          backdrop: `
          rgba(0,0,123,0.4)
          url("/images/nyan-cat.gif")
          left top
          no-repeat
        `,
        })
        .finally(() => {});
    },
    notificacionproveedor() {
      if (this.flag) {
        this.playAudio(true);
        this.$swal
          .fire({
            title: "Nueva cuenta como proveedor creada.",
            width: 600,
            padding: "3em",
            background: "#fff",
            backdrop: `
          rgba(0,0,123,0.4)
          left top
          no-repeat
        `,
          })
          .catch(() => {
            this.playAudio(false);
          })
          .finally(() => {
            this.playAudio(false);
          });
      } else {
        this.flag = true;
      }
    },
    activarNotificacionCronometro(value) {
      this.$toast.error(
        "Ya han pasado más de 10 minutos para la asistencia: " + value,
        {
          id: value,
          position: "bottom-left",
          closeOnClick: true,
          draggable: false,
          timeout: 10000,
          pauseOnHover: false,
          closeButton: false,
        }
      );
    },
    activarNotificacionSolicitudWeb() {
      this.$swal
        .fire({
          title: "Nueva solicitud web se encuentra en el modulo.",
          width: 600,
          padding: "3em",
          background: "#fff",
          backdrop: `
            rgba(0,0,123,0.4)
            left top
            no-repeat
              `,
        })
        .then(() => {});
    },
    playAudio(banderaAudio) {
      if (!this.audio) return;

      if (banderaAudio) {
        this.audio.play().catch(() => {});
      } else {
        this.audio.pause();
      }
    },
  },
};
</script>

<style>
@media print {
  @page {
    size: letter;
    margin: 0;
  }
  header,
  footer,
  nav,
  aside {
    display: none !important;
  }
  .dont-print {
    display: none !important;
  }
  body {
    background-color: white;
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    -ms-print-color-adjust: exact;
    print-color-adjust: exact;
    transform-origin: top left;
  }
}

.color {
  background: #00d2ff;
  background: -webkit-linear-gradient(to right, #3a7bd5, #00d2ff);
  background: linear-gradient(to right, #3a7bd5, #00d2ff);
}
#mySidenav a {
  position: absolute;
  right: -125px;
  transition: 0.3s;
  padding: 10px;
  width: 150px;
  text-decoration: none;
  font-size: 20px;
  color: white;
  border-radius: 5px 0 0 5px;
}
#mySidenav a:hover {
  right: 0;
}
#dialogMap {
  top: 110px;
  background-color: #ebaf2e;
  color: brown;
}
</style>
